<script setup>
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";

import useCourseTable from "@/scripts/Courses/CourseTable";
import ConfirmationModal from "@/components/ConfirmationModal.vue";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const {
  columns,
  tableData,
  tableOptions,
  handleSearch,
  handleSortChange,
  onSelect,
  onDeselect,
  handleLengthChange,
  onPageChange,
  deleteCourses,
  showConfirmModal,
  confirmModalTitle,
  confirmModalMessage,
  openDeleteConfirmation,
} = useCourseTable();
</script>

<template>
  <div class="table-responsive">
    <div class="card-body">
      <div class="mb-3">
        <button @click="openDeleteConfirmation" class="btn btn-secondary">
          <i class="bi bi-trash"></i> DELETE
        </button>
      </div>
      <DataTable
        :data="tableData"
        :columns="columns"
        :options="tableOptions"
        @page="onPageChange"
        @select="(event, dt, type) => onSelect({ event, dt, type })"
        @deselect="(event, dt, type) => onDeselect({ event, dt, type })"
        @length="(event, dt) => handleLengthChange({ event, dt })"
        @search="(event, dt) => handleSearch({ event, dt })"
        @order="(event, dt) => handleSortChange({ event, dt })"
        class="table table-hover table-bordered table-spacing"
        width="100%"
      >
      </DataTable>
    </div>
  </div>

  <ConfirmationModal
    :show="showConfirmModal"
    :title="confirmModalTitle"
    :message="confirmModalMessage"
    :confirmColor="'danger'"
    :cancelText="'CANCEL'"
    confirmText="DELETE"
    @confirm="deleteCourses"
    @close="showConfirmModal = false"
  />
</template>

<style>
.table-responsive {
  overflow-x: auto;
}
.table-spacing {
  margin: 5px 0 !important;
}
</style>
